const Star = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 22.3059L20.8604 25.548C21.8421 26.1421 23.0433 25.2638 22.785 24.153L21.3642 18.0563L26.1046 13.9488C26.97 13.1996 26.505 11.7788 25.3683 11.6884L19.1296 11.1588L16.6883 5.39797C16.2492 4.35172 14.7508 4.35172 14.3117 5.39797L11.8704 11.1459L5.63167 11.6755C4.495 11.7659 4.03 13.1867 4.89542 13.9359L9.63584 18.0434L8.215 24.1401C7.95667 25.2509 9.15792 26.1292 10.1396 25.5351L15.5 22.3059Z"
        fill="white"
      />
    </svg>
  );
};

export default Star;
